import {useKeenSlider} from 'keen-slider/react';
import {useTranslation} from 'react-i18next';

/**
 * Custom hook for the `MapCategoryFilter` component.
 * Wraps keen-slider (`perView: 'auto'`, so chips of different widths lay out naturally) to give
 * the category chip row proper drag/swipe momentum on both touch and mouse, instead of relying
 * on native `overflow-x` scrolling.
 *
 * @returns An object containing `sliderRef`, the ref callback for the slider track element, and `t`.
 */
export const useMapCategoryFilter = () => {
    const [sliderRef] = useKeenSlider<HTMLDivElement>({
        slides: {
            perView: 'auto',
            spacing: 8
        }
    });
    const {t} = useTranslation();

    return {
        sliderRef,
        t
    };
};